export const commonDict =
    {

        taskTypeConfig: {
            '0': {color: "#4A90E2", label: "个人开户", show: true, qrType: 'data_collection_confirm'},        // 信任蓝
            '1': {color: "#34C759", label: "企业开户", show: true, qrType: 'data_collection_confirm'},        // 企业绿
            '18': {color: "#34C759", label: "企业开户", show: true, qrType: 'data_collection_confirm'},        // 企业绿
            '2': {color: "#FF9500", label: "个人贷款申请", show: true, qrType: 'data_collection_confirm'},    // 警示橙
            '3': {color: "#5856D6", label: "企业贷款申请", show: true, qrType: 'data_collection_confirm'},    // 商务紫
            '4': {color: "#5AC8FA", label: "归集协议添加", show: true, qrType: 'data_collection_confirm'},    // 连接青
            '5': {color: "#007AFF", label: "个人开户信息变更", show: true, qrType: 'data_collection_confirm'},// 深信任蓝
            '6': {color: "#28CD41", label: "企业开户信息变更", show: true, qrType: 'data_collection_confirm'},// 深企业绿
            '7': {color: "#AF52DE", label: "个人自助开户", show: true, qrType: 'SelfAccountOpen'},    // 自助紫
            '8': {color: "#32ADE6", label: "企业自助开户", show: true, qrType: 'selfEntAccOpen'},    // 自助蓝
            '9': {color: "#8E8E93", label: "账户销户", show: true, qrType: 'data_collection_confirm'},        // 中性灰
            '10': {color: "#FF3B30", label: "余额支付", show: true, qrType: 'data_collection_confirm'},       // 支付红
            '11': {color: "#FF6905", label: "融资支付", show: true, qrType: 'data_collection_confirm'},      // 融资橙
            '12': {color: "#FF2D55", label: "清分支付", show: true, qrType: 'data_collection_confirm'},       // 清分红
            '13': {color: "#A2845E", label: "非银垫资", show: true, qrType: 'data_collection_confirm'},       // 金融棕
            '14': {color: "#68758E", label: "非银清算", show: true, qrType: 'data_collection_confirm'},       // 清算灰
            '15': {color: "#0D4D4D", label: "合约支付", show: true, qrType: 'data_collection_confirm'},
            '16': {color: "#9D4D4D", label: "个人邀请自助开户", show: true, qrType: 'SelfAccountOpen'},
            '17': {color: "#0D4D4D", label: "企业手机号变更", show: true, qrType: 'SelfAccountOpen'},
            default: {color: "#C7C7CC", label: "未知", show: false, qrType: 'data_collection_confirm'},       // 浅中性灰
        },
        taskStatusConfig: {
            '0': {color: "#4A90E2", label: "待处理", show: true},
            '1': {color: "#34C759", label: "已处理", show: true},
            '2': {color: "#FF2D55", label: "处理失败", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},

        },
        goodsTypeConfig: {
            '11': {color: "#DB5409", label: "商品类", show: true, addShow: true},
            '10': {color: "#DB5409", label: "商品类（特殊）", show: true, addShow: true},
            '12': {color: "#DB5409", label: "商品类（大电商）", show: true, addShow: true},
            '13': {color: "#DB5409", label: "商品类（团长）", show: true, addShow: true},

            '20': {color: "#FF6B6B", label: "娱乐类", show: true, addShow: false},
            '30': {color: "#DBC309", label: "资金类", show: true, addShow: true},

            '40': {color: "#01D1DB", label: "代销类", show: true, addShow: true},
            '41': {color: "#01D1DB", label: "代销类(特殊)", show: true, addShow: false},

            '50': {color: "#7509DB", label: "权益类", show: true, addShow: true},
            '51': {color: "#6d8f29", label: "物流类", show: true, addShow: true},      //

            default: {color: "#C7C7CC", label: "未知", show: false, addShow: false},
        },

        //     贷款状态（0、开户，1、正常，2、逾期，3、结清，4、销户，5、申报核销，6、部分核销，7、全部核销）
        loanStatusConfig: {
            '0': {color: "#4A90E2", label: "开户", show: true},
            '1': {color: "#34C759", label: "正常", show: true},
            '2': {color: "#FF9500", label: "逾期", show: true},
            '3': {color: "#FF2D55", label: "结清", show: true},
            '4': {color: "#8E8E93", label: "销户", show: true},
            '5': {color: "#FF3B30", label: "申报核销", show: true},
            '6': {color: "#FF6905", label: "部分核销", show: true},
            '7': {color: "#FF2D55", label: "全部核销", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},

        },
        // 贷款形态（0、正常 1、逾期 2、呆滞 3、呆账 4、部分逾期 5、部分呆滞）
        loanFormConfig: {
            '0': {color: "#4A90E2", label: "正常", show: true},
            '1': {color: "#FF9500", label: "逾期", show: true},
            '2': {color: "#FF2D55", label: "呆滞", show: true},
            '3': {color: "#8E8E93", label: "呆账", show: true},
            '4': {color: "#FF3B30", label: "部分逾期", show: true},
            '5': {color: "#FF6905", label: "部分呆滞", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        // 还款方式：1、等本 2、等额 3、按期付息、按期还本 4、一次性还本付息 5、按期付息，任意还本 6、任意还本，利随本清 7、按期付息，到期一次性还本
        repaymentMethodConfig: {
            '1': {color: "#4A90E2", label: "等本", show: true},
            '2': {color: "#34C759", label: "等额", show: true},
            '3': {color: "#FF9500", label: "按期付息、按期还本", show: true},
            '4': {color: "#FF2D55", label: "一次性还本付息", show: true},
            '5': {color: "#8E8E93", label: "按期付息，任意还本", show: true},
            '6': {color: "#FF3B30", label: "任意还本，利随本清", show: true},
            '7': {color: "#FF6905", label: "按期付息，到期一次性还本", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},

        },

        //状态 0-待支付 1-保证中 2-成功 3-已退
        guaranteeStatusConfig: {
            '0': {color: "#ffbf00", label: "待确认", show: true},
            '1': {color: "#5AC8FA", label: "冻结中", show: true},
            '2': {color: "#34C759", label: "已完成", show: true},
            '3': {color: "#FF2D55", label: "退回失败", show: true},
            '4': {color: "#AF52DE", label: "原路退回", show: true},
            '5': {color: "#8E8E93", label: "已作废", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        // //状态 0-待支付 1-已支付 2-失败 3-已退
        certOrderFeeStatusConfig: {
            '0': {color: "#4A90E2", label: "待支付", show: true},
            '1': {color: "#34C759", label: "已支付", show: true},
            '2': {color: "#FF2D55", label: "失败", show: true},
            '3': {color: "#8E8E93", label: "已退还", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },

        //非银融资人 业务类型
        nbiBusTypeConfig: {
            '0': {color: "#4A90E2", label: "社资", show: true},
            '1': {color: "#34C759", label: "清算(通用)", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},

        },
        AcctRegStatusConfig: {
            'PENDING': {color: "#ffbf00", label: "待审核", show: true},
            'APPROVED': {color: "#34C759", label: "审核通过", show: true},
            'REJECTED': {color: "#FF2D55", label: "已拒绝", show: true},
            'OPEN_FAILED': {color: "#8E8E93", label: "开户失败", show: true},
            'ACTIVE': {color: "#34C759", label: "已开户", show: true},
            'CANCELED': {color: "#8E8E93", label: "已撤销", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        // 0：其他 1：身份证 2：户口本 3：学生证 4：军官证 5：武警证 6：士兵证 7：中国护照 8：香港通行证 9：澳门通行证 A：台湾通行证 B：外国护照 C：工商注册登记号
        idTypeList: {
            '1': {color: "#34C759", label: "身份证", show: true},
            '2': {color: "#FF9500", label: "户口本", show: true},
            '3': {color: "#FF2D55", label: "学生证", show: true},
            '4': {color: "#8E8E93", label: "军官证", show: true},
            '5': {color: "#FF3B30", label: "武警证", show: true},
            '6': {color: "#FF6905", label: "士兵证", show: true},
            '7': {color: "#AF52DE", label: "中国护照", show: true},
            '8': {color: "#5AC8FA", label: "香港通行证", show: true},
            '9': {color: "#FF2D55", label: "澳门通行证", show: true},
            'A': {color: "#34C759", label: "台湾通行证", show: true},
            'B': {color: "#FF2D55", label: "外国护照", show: true},
            'C': {color: "#8E8E93", label: "工商注册登记号", show: true},
            '0': {color: "#4A90E2", label: "其他", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        sexList:{
            '0': {color: "#34C759", label: "男", show: true},
            '1': {color: "#FF9500", label: "女", show: true},
            '2': {color: "#4A90E2", label: "未知", show: true},
        },
        religionTypes: {
            'buddhism': {color: "#FF9800", label: "佛教", show: true},
            'taoism': {color: "#3F51B5", label: "道教", show: true},
            'islam': {color: "#4CAF50", label: "伊斯兰教", show: true},
            'catholicism': {color: "#9C27B0", label: "天主教", show: true},
            'protestantism': {color: "#F44336", label: "基督教", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        // 证件类型
        /**
         *     FILE_TYPE_01("01", "人像面"),
         *     FILE_TYPE_02("02", "国徽面"),
         *     FILE_TYPE_03("03", "银行卡"),
         *     FILE_TYPE_04("04", "人脸识别"),
         *     FILE_TYPE_12("12", "营业执照"),
         *     FILE_TYPE_13("13", "开户协议"),
         *     FILE_TYPE_14("14", "个人征信授权"),
         *     FILE_TYPE_15("15", "第三方数据信息查询和使用授权书"),
         *     FILE_TYPE_16("16", "结婚证明（非必填）"),
         *     FILE_TYPE_17("17", "经营证明（涉及经营企业必填）"),
         *     FILE_TYPE_21("21", "企业征信授权"),
         *     FILE_TYPE_22("22", "企业章程"),
         *     FILE_TYPE_23("23", "决议书"),
         *
         *
         *
         *     FILE_TYPE_101("101", "负责人身份证人像面"),
         *     FILE_TYPE_102("102", "负责人身份证国徽面"),
         *     FILE_TYPE_103("103", "负责人戒碟"),
         *     FILE_TYPE_104("104", "宗教活动场所登记证"),
         */

        fileTypeList: {
            '01': {color: "#34C759", label: "人像面", show: true},
            '02': {color: "#FF9500", label: "国徽面", show: true},
            '03': {color: "#FF2D55", label: "银行卡", show: true},
            '04': {color: "#8E8E93", label: "人脸识别", show: true},
            '12': {color: "#FF3B30", label: "营业执照", show: true},
            '13': {color: "#FF6905", label: "开户协议", show: true},
            '14': {color: "#5AC8FA", label: "个人征信授权", show: true},
            '15': {color: "#AF52DE", label: "第三方数据信息查询和使用授权书", show: true},
            '16': {color: "#34C759", label: "结婚证明（非必填）", show: true},
            '17': {color: "#FF2D55", label: "经营证明（涉及经营企业必填）", show: true},
            '21': {color: "#8E8E93", label: "企业征信授权", show: true},
            '22': {color: "#FF3B30", label: "企业章程", show: true},
            '23': {color: "#5AC8FA", label: "决议书", show: true},
            '101': {color: "#34C759", label: "负责人身份证人像面", show: true},

            '102': {color: "#FF9500", label: "负责人身份证国徽面", show: true},
            '103': {color: "#FF2D55", label: "负责人戒碟", show: true},
            '104': {color: "#8E8E93", label: "宗教活动场所登记证", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },

        loanStatusMap: {
            '0': {label: '未知', color: "#C7C7CC",},
            '1': {label: '成功',color: "#34C759", },
            '2': {label: '失败', color: "#FF2D55",},
            '3': {label: '处理中',color: "#ffbf00",},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },

        flagMap: {
            '0': {label: '否', color: "#C7C7CC",},
            '1': {label: '是',color: "#34C759", },
            default: {color: "#C7C7CC", label: "未知", show: false},
        },
        //还款状态
        repayStatus: {
            default: {color: "#C7C7CC", label: "未知", show: false},
            '0': {label: '未知', color: '#C7C7CC'},
            '1': {label: '成功', color: '#34C759'},
            '2': {label: '失败', color: '#FF2D55'}
        },
        //还款方式
        repayWay: {
            default: {label: '未知', color: '#C7C7CC'},
            '0': {label: '部分还款', color: '#ffbf00'},
            '1': {label: '全部还款', color: '#34C759'},
        },
        //还款类型
        repayType:{
            default: {label: '未知', color: '#C7C7CC'},
            '0': {label: '自动还款', color: '#5AC8FA'},
            '1': {label: '主动还款', color: '#34C759'},
        },
        // 批次状态
        batch_status: {
            //批次状态：0-待匹配，1-已匹配，2-待清算，3-清算完成  4-清算失败，5-已作废  6-部分清算
            '0': {color: "#ffb9b9", label: "未匹配", show: true},
            '1': {color: "#63acff", label: "待确认", show: true},
            '2': {color: "#004697", label: "待清算", show: true},
            '3': {color: "#34c759", label: "清算完成", show: true},
            '4': {color: "#ff2d55", label: "清算失败", show: true},
            '5': {color: "#a1a1a1", label: "已作废", show: true},
            '6': {color: "#ffbf00", label: "部分清算", show: true},

            default: {color: "#C7C7CC", label: "未知", show: false},
        },



        flow_status: {
            //流水：0-待匹配，1-已匹配，2-待清算，3-清算完成  4-清算失败，5-已作废  6-部分清算
            '0': {color: "#ffb9b9", label: "未匹配", show: true},
            '1': {color: "#63acff", label: "待确认", show: true},
            '2': {color: "#004697", label: "待清算", show: true},
            '3': {color: "#34c759", label: "清算完成", show: true},
            '4': {color: "#ff2d55", label: "清算失败", show: true},
            '5': {color: "#a1a1a1", label: "已作废", show: true},
            '6': {color: "#ffbf00", label: "部分清算", show: true},
            '7': {color: "#5f98d7", label: "部分匹配", show: true},

            default: {color: "#C7C7CC", label: "未知", show: false},
        },

        flowFee_status: {
            //服务费状态：0-未处理，1-处理中，2-处理完成
            '0': {color: "#FF2D55", label: "未处理", show: true},
            '1': {color: "#ffbf00", label: "成功", show: true},
            '2': {color: "#34C759", label: "失败", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },


        flowMatch_type:{
            //匹配类型：1-自动匹配，2-人工匹配
            '1': {color: "#ffbf00", label: "自动匹配", show: true},
            '2': {color: "#34C759", label: "人工匹配", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },


        settle_status: {
            //清算状态：0-待清算，1-清算成功，2-清算失败 3-清算部分
            '0': {color: "#ffbf00", label: "待清算", show: true},
            '1': {color: "#34C759", label: "清算成功", show: true},
            '2': {color: "#FF2D55", label: "清算失败", show: true},
            '3': {color: "#FF2D55", label: "清算部分", show: true},
            '4': {color: "#FF2D55", label: "已作废", show: true},


            default: {color: "#C7C7CC", label: "未知", show: false},
        },

        flowSettle_type:{
            //清算类型：1-自动清算，2-人工清算
            '1': {color: "#ffbf00", label: "自动清算", show: true},
            '2': {color: "#34C759", label: "人工清算", show: true},
            default: {color: "#C7C7CC", label: "未知", show: false},
        },


        stl_acc_signType:{
            //RSA/SM2/MD5
            'RSA': {color: "#ffbf00", label: "RSA", show: true},
            'SM2': {color: "#34C759", label: "SM2", show: true},
            'MD5': {color: "#FF2D55", label: "MD5", show: true},

            default: {color: "#C7C7CC", label: "未知", show: false},
        },


    };
